/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgTemplateOutlet } from '@angular/common';
import { Component, output, TemplateRef, viewChild } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipDirective, TooltipModule } from 'ngx-bootstrap/tooltip';

import { SelectItem } from '@bn/primitives';

import { BadgeComponent } from '../../../../badge/badge.component';
import { FlagComponent } from '../../../../flag/flag.component';
import { IndicatorSelectTemplateComponent } from '../indicator-select-template/indicator-select-template.component';

@Component({
  selector: 'bn-web-ui-label-select-template',
  templateUrl: './label-select-template.component.html',
  imports: [BadgeComponent, FaIconComponent, FlagComponent, IndicatorSelectTemplateComponent, NgTemplateOutlet, TooltipModule],
  providers: [TooltipDirective],
})
export class LabelSelectTemplateComponent {
  // Default call this with type
  readonly labelTemplate = viewChild.required<TemplateRef<any>>('labelTemplate');

  // Event that triggers clear all at parent model
  readonly clear = output<SelectItem>();

  // Emit clear all event
  emitClear(item: SelectItem): void {
    this.clear.emit(item);
  }
}
